<template>
    <v-dialog v-model="dialog" max-width="700px">
        <v-card id="qj-dialog-configuration-approach-flow">
            <v-card-title
                style="height: 60px; display: flex; align-items: center; justify-content: space-between; align-content: center;">
                <v-toolbar-title style="line-height: 20px; height: 30px !important;">
                    <v-text-field full-width single-line hide-details label="Asset" value="Asset"></v-text-field>
                </v-toolbar-title>
                <v-btn icon @click="$emit('close')">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text class="pa-0">
                <v-form ref="form" lazy-validation>
                    <span v-html='templateAsset'>
                    </span>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import serviceGetAsset from "@/services/linkAsset.js";

export default {
    props: ["dialog", "linkAsset"],
    data() {
        return {
            templateAsset: "",
        };
    },
    async created() {
        await this.getHtmlUrl();
    },
    methods: {
        async getHtmlUrl() {
            this.templateAsset = await serviceGetAsset.getAsset(this.linkAsset);
        }
    },
};
</script>

<style>

</style>
